import { Tooltip } from '@material-ui/core'
import { Typography } from '@material-ui/core'
import React from 'react'

import { getTranslate, lang } from '../../localization'
import useStyles from './styles/maxMin.styles'

type MaxMinProps = {
  title: string
  duration: string
  name: string
}

function extractLargestUnit(duration: string): string {
  let sections = []
  if (duration != '') {
    if (lang === 'fa') {
      sections = duration.split(' و')
    } else {
      sections = duration.split('and')
    }
    return sections[0] + ' ...'
  } else {
    return '-'
  }
}

function MaxMin({ duration, name, title }: MaxMinProps) {
  const classes = useStyles({ title })

  return (
    <div className={classes.row}>
      <Typography variant="caption">{getTranslate(title)} :</Typography>
      <div>
        <Tooltip placement="bottom" title={duration} aria-label="duration">
          <Typography variant="caption">
            {extractLargestUnit(duration)}
          </Typography>
        </Tooltip>
      </div>
      <div>
        <Typography variant="caption">{name}</Typography>
      </div>
    </div>
  )
}

export default MaxMin
